<div class="container">
  <!-- Header Row -->
  <mat-dialog-actions class="w-100">
    <div class="header-row phi-flex-center phi-justify-content-between phi-gap-12 w-100">
      <h3 class="popup-heading ml-15">Video List</h3>
      <!-- <div class="popup-close"> -->
      <button mat-icon-button mat-dialog-close class="close-btn">
        <ion-icon name="close-outline"></ion-icon>
      </button>
      <!-- </div> -->
    </div>
  </mat-dialog-actions>

  <!-- Video Grid -->
  <mat-dialog-content>
    <ion-row class="video-grid">
      <ion-col size="12" size-sm="6" size-md="4" *ngFor="let video of videos; trackBy: trackByFn">
        <div class="video-card">
          <!-- Title -->
          <h4 class="video-title" [title]="video.title">{{ video.title }}</h4>

          <!-- Embed Iframe -->
          <ng-container *ngIf="!video.isInstagram && !video.isFile">
            <iframe width="100%" height="200" [src]="video.sanitizedUrl" frameborder="0" allowfullscreen></iframe>
          </ng-container>

          <video *ngIf="video.isFile" width="100%" height="200" controls [src]="video.sanitizedUrl"></video>

          <!-- Direct Video File -->
          <ng-container *ngIf="video.isFile">
            <video width="100%" height="200" [src]="video.url" controls></video>
          </ng-container>

          <!-- Instagram Link -->
          <ng-container *ngIf="video.isInstagram">
            <a [href]="video.url" target="_blank">View on Instagram</a>
          </ng-container>

          <!-- Flipkart Links -->
          <ng-container *ngIf="isFlipkartUrl(video.url)">
            <a [href]="video.url" target="_blank" class="platform-link">View on Flipkart</a>
          </ng-container>

          <!-- Description -->
          <p class="video-description" [title]="video.description">{{ video.description }}</p>
        </div>
      </ion-col>
    </ion-row>
  </mat-dialog-content>
</div>
